import {
  createServerSideDatasource,
  foldFiltersToSearchText,
} from '../../grid/iLocalAGGrid';

export const getAccountResourceAuthHeaders = () => {
  try {
    const raw = sessionStorage.getItem('user');
    if (!raw) {
      return null;
    }
    const user = JSON.parse(raw);
    const token =
      user &&
      user.signInUserSession &&
      user.signInUserSession.idToken &&
      user.signInUserSession.idToken.jwtToken;
    if (!token) {
      return null;
    }
    return {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    };
  } catch (e) {
    return null;
  }
};

/**
 * SSRM datasource for account-scoped list endpoints (searchtext + sort only).
 */
export const createAccountResourceDatasource = ({
  filterObj,
  sortMap,
  endpoint,
  getAccountId,
  getExtraBody,
}) =>
  createServerSideDatasource({
    filterBody: filterObj,
    applyFilterModel: (body, filterModel) => {
      body.searchtext = foldFiltersToSearchText(filterModel);
    },
    sortMap,
    pageZeroBased: true,
    getPageSize: () => filterObj.pageSize || 10,
    fetchPage: (body) => {
      const headers = getAccountResourceAuthHeaders();
      if (!headers) {
        return Promise.resolve({ results: [], total: 0 });
      }
      body.accountId = getAccountId();
      const extra = getExtraBody ? getExtraBody() : null;
      if (extra) {
        Object.assign(body, extra);
      }
      return fetch(process.env.REACT_APP_BASEURL + endpoint, {
        method: 'post',
        withCredentials: true,
        headers,
        body: JSON.stringify(body),
      }).then((response) => response.json());
    },
  });

export const syncGridPageSize = (params, filterObj) => {
  if (!params || !params.api || !filterObj) {
    return;
  }
  const newPageSize = params.api.paginationGetPageSize();
  if (newPageSize && filterObj.pageSize !== newPageSize) {
    filterObj.pageSize = newPageSize;
  }
};

/**
 * Safely resolve AccountLevel kiosk hours (child accounts may omit the graph).
 */
export const getAccountLevelKioskHours = (selectedObject) => {
  const ops =
    selectedObject && Array.isArray(selectedObject.kiosk_hoursof_operations)
      ? selectedObject.kiosk_hoursof_operations
      : [];
  return ops.filter((item) => item && item.hop_type === 'AccountLevel');
};



// WEBPACK FOOTER //
// ./src/components/account-list/related/accountResourceGridUtils.js